import * as types from '../actions/actionTypes';
import { assign, cloneDeep, map, size, remove, concat, findIndex, find } from 'lodash';

const initialState = {
  facilitiesMasterList: [],
  garageProfileDetails: {},
  companyImages: [],
  'newGarageProfileData': {
    'images': []
  },
  hideButtonLoader: true,
  ratingsAndReviews: [],
  reviewsAndRatingsData: [],
  reviewsAndRatingsDataLoaded: false,
  reviewsAndRatingsOverView: {},
  garageServicesError: {
    'washError': false,
    'serviceError': false,
    'repairError': false,
    'emergencyError': false,
    'manufacturerError': false
  }
};
export default function vendorProfileReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_FACILITIES_MASTER:
      return assign({}, state, { facilitiesMasterList: action.facilitiesMasterList });
    case types.GET_GARAGE_PROFILE: {
      if (action.unableToFetch) {
        return assign({}, state, {
          isVendorProfileLoaded: true,
          unableToFetchVendorProfile: true,
        });
      } else {
        let images = [];
        map(action.garageProfileDetails.images, (image) => {
          images.push(
            {
              isUploaded: true,
              isFailed: false,
              isCover: image.isCover,
              id: image.id,
              thumbnail: image.medium,
              original: image.original,
            });
        });
        let newGarageProfileData = cloneDeep(state.newGarageProfileData);
        newGarageProfileData.images = images;
        newGarageProfileData.batch_id = action.garageProfileDetails.batchId;
        return assign({}, state, {
          isVendorProfileLoaded: true,
          unableToFetchVendorProfile: false,
          newGarageProfileData: newGarageProfileData,
          garageProfileDetails: action.garageProfileDetails,
          companyImages: action.garageProfileDetails.images,
        });
      }
    }

    case types.GET_SERVICES_VENDOR_PROFILE: {
      return assign({}, state, {
        allGarageServices: action && action.allServices
      });
    }

    case types.GET_SERVICES:
      {
        if (action.unableToFetch) {
          return assign({}, state, {
            isManageServicesLoaded: true,
            unableToFetchManageServices: true,
          });
        } else {
          let garageWashTypes = splitServices(action.allServices, action.garageServices, 'Wash');
          let garageRepairTypes = splitServices(action.allServices, action.garageServices, 'Repair');
          let garageServiceTypes = splitServices(action.allServices, action.garageServices, 'Servicing');
          let garageEmergencyTypes = splitServices(action.allServices, action.garageServices, 'Emergency Service');
          let manufacturers = [];
          map(action.allManufacturers, (brand) => {
            let brandIndex = findIndex(action.supportedManufacturers, { carmodelId: brand.id });
            manufacturers.push({
              "id": brand.id,
              "name": brand.name,
              "status": brandIndex != -1 ? 1 : 0
            });
          });

          return assign({}, state, {
            garageManufacturers: manufacturers,
            garageRepairTypes: garageRepairTypes.s,
            garageRepairParentTypes: garageRepairTypes.p,
            repairTSD: garageRepairTypes.t,
            garageWashTypes: garageWashTypes.s,
            washTSD: garageWashTypes.t,
            garageServiceTypes: garageServiceTypes.s,
            servicingTSD: garageServiceTypes.t,
            garageEmergencyTypes: garageEmergencyTypes.s,
            emergencyTSD: garageEmergencyTypes.t,
            isManageServicesLoaded: true,
            unableToFetchManageServices: false,
            allGarageServices: action.allServices
          });
        }
      }
    case types.VENDOR_PROFILE_DETAILS_UPDATED:
      return assign({}, state, { garageProfileDetails: {}, hideButtonLoader: true });
    case types.ADD_MANUFACTURERS: {
      if (action.unableToFetch) {
        return assign({}, state, {
          garageServicesError: {
            ...state.garageServicesError,
            'washError': false,
            'serviceError': false,
            'repairError': false,
            'emergencyError': false,
            'manufacturerError': true
          }
        });
      } else {
        return assign({}, state, { garageManufacturers: action.manufacturers });
      }
    }
    case types.CHANGE_COVER_IMAGE: {
      let newGarageProfileData = cloneDeep(state.newGarageProfileData);
      let index = findIndex(newGarageProfileData.images, { id: action.imageId });
      if (index != -1) {
        map(newGarageProfileData.images, (image, key) => {
          if (index == key) {
            newGarageProfileData.images[key].isCover = true;
          } else {
            newGarageProfileData.images[key].isCover = false;
          }
        });
      }
      return assign({}, state, { newGarageProfileData: newGarageProfileData });
    }
    case types.ADD_GARAGE_IMAGES: {
      let companyImages = cloneDeep(state.companyImages);
      let newImages = action.companyImages;
      map(newImages, (image, index) => {
        companyImages.push(newImages[index]);
      });
      return assign({}, state, { companyImages: companyImages });
    }
    case types.CHANGE_COMPANY_LOGO: {
      let garageProfileDetails = cloneDeep(state.garageProfileDetails);
      garageProfileDetails.logo = action.updatedImage;
      return assign({}, state, { garageProfileDetails: garageProfileDetails });
    }
    case types.UPLOAD_GARAGE_IMAGE_SUCCESS: {
      let newGarageProfileData = cloneDeep(state.newGarageProfileData);
      newGarageProfileData.images = size(newGarageProfileData.images) ? newGarageProfileData.images : [];
      newGarageProfileData.images.push(action.image);
      newGarageProfileData.totalImages = action.totalImageLength;
      newGarageProfileData.uploadedImagesCount = newGarageProfileData.images.length;
      return assign({}, state, { newGarageProfileData: newGarageProfileData });
    }
    case types.UPLOAD_GARAGE_IMAGE_FAILED: {
      let newGarageProfileData = cloneDeep(state.newGarageProfileData);
      newGarageProfileData.images = size(newGarageProfileData.images) ? newGarageProfileData.images : [];
      newGarageProfileData.images.push(action.image);
      newGarageProfileData.totalImages = action.totalImageLength;
      newGarageProfileData.uploadedImagesCount = newGarageProfileData.images.length;
      return assign({}, state, { newGarageProfileData: newGarageProfileData });
    }
    case types.CREATE_GARAGE_PROFILE_BATCH_ID: {
      let newGarageProfileData = cloneDeep(state.newGarageProfileData);
      newGarageProfileData.batch_id = action.batch_id;
      return assign({}, state, { newGarageProfileData: newGarageProfileData });
    }
    case types.CLEAR_GARAGE_PROFILE_BATCH_ID: {
      return assign({}, state, { newGarageProfileData: {} });
    }
    case types.DELETE_GARAGE_IMAGE: {
      let newGarageProfileData = cloneDeep(state.newGarageProfileData);
      remove(newGarageProfileData.images, (image) => {
        return image.id == action.imageId;
      });
      return assign({}, state, { newGarageProfileData: newGarageProfileData, deletedImageId: action.imageId });
    }
    case types.GET_REVIEWS_AND_RATINGS: {
      let a = cloneDeep(action.ratingsAndReviews);
      let ratingsAndReviews = [];
      let b = cloneDeep(state.ratingsAndReviews);
      ratingsAndReviews = action.fromLoadMore ? concat(b, a) : a;
      return assign({}, state, {
        ratingsAndReviews: ratingsAndReviews,
        ratingsOverview: action.ratingsOverview,
      });
    }
    case types.ADD_GARAGE_SERVICES: {
      if (action.unableToFetch) {
        return assign({}, state, {
          garageServicesError: {
            ...state.garageServicesError,
            'washError': action.serviceType == 1 ? true : false,
            'serviceError': action.serviceType == 2 ? true : false,
            'repairError': action.serviceType == 3 ? true : false,
            'emergencyError': action.serviceType == 4 ? true : false,
            'manufacturerError': false
          }
        });
      } else {
        return assign({}, state, {
          garageRepairTypes: action.serviceType == 3 ? action.updatedServices : state.garageRepairTypes,
          garageWashTypes: action.serviceType == 1 ? action.updatedServices : state.garageWashTypes,
          garageServiceTypes: action.serviceType == 2 ? action.updatedServices : state.garageServiceTypes,
          garageEmergencyTypes: action.serviceType == 4 ? action.updatedServices : state.garageEmergencyTypes,
          garageServicesError: {
            ...state.garageServicesError,
            'washError': false,
            'serviceError': false,
            'repairError': false,
            'emergencyError': false,
            'manufacturerError': false
          }
        });
      }
    }
    case types.GET_ALL_SERVICES: {
      return assign({}, state, {
        getAllServices: action.allServices
      });
    }
    case types.GET_VENDOR_REVIEWS_AND_RATINGS: {
      if (action.unableToFetch) {
        return assign({}, state, {
          reviewsAndRatingsDataLoaded: true
        });
      } else {
        let reviewData = action.reviewsAndRatingsData && action.reviewsAndRatingsData.reviewsDetails ? action.reviewsAndRatingsData.reviewsDetails : []
        let reviewsAndRatingsData = cloneDeep(state.reviewsAndRatingsData);
        if (action.offset) {
          reviewsAndRatingsData = reviewsAndRatingsData.concat(reviewData);
        } else {
          reviewsAndRatingsData = reviewData;
        }
        return assign({}, state, {
          reviewsAndRatingsDataLoaded: true,
          reviewsAndRatingsData: reviewsAndRatingsData,
          reviewsAndRatingsOverView: action.reviewsAndRatingsData && action.reviewsAndRatingsData.overview ? action.reviewsAndRatingsData.overview : state.reviewsAndRatingsOverView
        });
      }
    }
    case types.DELETE_COMMENTS_ON_REVIEW: {
      let reviewsAndRatingsData = cloneDeep(state.reviewsAndRatingsData);
      let reviewIndex = findIndex(reviewsAndRatingsData, { 'id': action.reviewId });
      if (reviewIndex != -1) {
        let comments = cloneDeep(reviewsAndRatingsData[reviewIndex].comments_on_review);
        remove(comments, { 'id': action.commentId });
        reviewsAndRatingsData[reviewIndex].comments_on_review = comments;
      }
      return assign({}, state, {
        reviewsAndRatingsData: reviewsAndRatingsData
      });
    }
    case types.UPDATE_COMMENTS_ON_REVIEW: {
      let reviewsAndRatingsData = cloneDeep(state.reviewsAndRatingsData);
      let updatedComment = action.responseData && action.responseData ? cloneDeep(action.responseData) : {};
      updatedComment.createdAt = updatedComment.created_at;
      updatedComment.reviewId = updatedComment.review_id;
      updatedComment.updatedAt = updatedComment.updated_at;
      updatedComment.user_id = updatedComment.user_id;
      if (action.isEdit) {
        let reviewIndex = findIndex(reviewsAndRatingsData, { 'id': action.reviewId });
        if (reviewIndex != -1) {
          let comments = cloneDeep(reviewsAndRatingsData[reviewIndex].comments_on_review);
          let commentIndex = findIndex(comments, { 'id': action.commentId });
          if (commentIndex != -1) {
            comments[commentIndex] = updatedComment;
          }
          reviewsAndRatingsData[reviewIndex].comments_on_review = comments;
        }
      } else {
        let reviewIndex = findIndex(reviewsAndRatingsData, { 'id': action.reviewId });
        if (reviewIndex != -1) {
          let comments = cloneDeep(reviewsAndRatingsData[reviewIndex].comments_on_review);
          comments.push(updatedComment);
          reviewsAndRatingsData[reviewIndex].comments_on_review = comments;
        }
      }
      return assign({}, state, {
        reviewsAndRatingsData: reviewsAndRatingsData
      });
    }
    default:
      return state;
  }
}

function splitServices(allServices, garageServices, serviceType) {
  let services = [];
  let parentServices = [];
  if (serviceType == 'Repair' || serviceType == 'Servicing') {
    let sub_services = find(allServices, { name: serviceType }) && find(allServices, { name: serviceType }).sub_services;
    if (serviceType == 'Servicing') {
      services = sub_services;
    } else {
      map(sub_services, (sub_service) => {
        services = concat(services, sub_service.sub_services);
        delete sub_service.sub_services;
        parentServices = concat(parentServices, sub_service);
      });
    }
  } else if (serviceType == 'Wash' || serviceType == 'Emergency Service') {
    let sub_services = find(allServices, { name: serviceType }) && find(allServices, { name: serviceType }).sub_services;
    services = concat(services, sub_services);
  }
  let updatedServices = [];
  let parentService = find(allServices, { name: serviceType });
  map(services, (service) => {
    let parent = {};
    if (serviceType == 'Repair' || serviceType == 'Servicing') {
      parent = find(parentService.sub_services, { id: service.parentId });
    } else if (serviceType == 'Wash' || serviceType == 'Emergency Service') {
      parent = parentService;
    }
    let garageService = find(garageServices, { serviceId: service.id });
    updatedServices.push({
      "service_id": parentService && parentService.id,
      "parentId": service.parentId,
      "id": garageService && garageService.serviceId ? garageService.serviceId : service.id,
      "uniqueId": garageService && garageService.id,
      "status": garageService && garageService.status ? garageService.status : 0,
      "descp_sedan": garageService && garageService.descpSedan ? garageService.descpSedan : '',
      "descp_suv": garageService && garageService.descpSuv ? garageService.descpSuv : '',
      "cost_sedan": garageService && garageService.costSedan ? garageService.costSedan : null,
      "cost_suvs": garageService && garageService.costSuvs ? garageService.costSuvs : null,
      "serviceTitle": service.name,
      "serviceDescription": service.description,
      "parentTitle": serviceType == 'Servicing' ? "Car Servicing" : parent && parent.name && parent.name,
      "parentImage": parent && parent.image ? parent.image : service.image,
      "parentDescription": parent && parent.description && parent.description,
      "isNew": garageService ? false : true,
      "inspectionamount": garageService && garageService.inspectionamount ? garageService.inspectionamount : 0,
      "isinspectionrequired": garageService && garageService.isinspectionrequired ? garageService.isinspectionrequired : false,
    });
  });
  let updatedParentServices = [];
  parentServices.forEach(p => {
    let garageService = find(garageServices, { serviceId: p.id });
    updatedParentServices.push({
      service_id: 3,
      id: p.id,
      parentId: p.parentId,
      uniqueId: garageService ? garageService.id : ''
    });
  });

  let topLevelServiceData = {}
  if (serviceType == 'Repair') {
    let garageService = find(garageServices, { serviceId: 3 });
    topLevelServiceData = {
      id: 3,
      uniqueId: garageService ? garageService.id : ''
    }
  } else if (serviceType == 'Wash') {
    let garageService = find(garageServices, { serviceId: 1 });
    topLevelServiceData = {
      id: 1,
      uniqueId: garageService ? garageService.id : ''
    }
  } else if (serviceType == 'Servicing') {
    let garageService = find(garageServices, { serviceId: 2 });
    topLevelServiceData = {
      id: 2,
      uniqueId: garageService ? garageService.id : ''
    }
  } else if (serviceType == 'Emergency Service') {
    let garageService = find(garageServices, { serviceId: 4 });
    topLevelServiceData = {
      id: 4,
      uniqueId: garageService ? garageService.id : ''
    }
  }

  return {s:updatedServices, p:updatedParentServices, t:topLevelServiceData};
}



// WEBPACK FOOTER //
// ./src/reducers/vendorProfileReducer.js